function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

var _excluded = ["children"];

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return _typeof(key) === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import { GenderFemale, GenderMale } from 'react-bootstrap-icons';
import { FormattedDate, FormattedMessage, useIntl } from 'react-intl';
import { EVENT_TYPE_BIRTH, EVENT_TYPE_DEATH } from '../api';
import { RANGE_ABOUT, RANGE_AFTER, RANGE_BEFORE, RANGE_BETWEEN, RANGE_EXACT } from '../form/DateRangeGroup';
import { normalizeTextToken, selectElementText, tokenizeAndNormalizeText, tokenizeText } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ResultListTable(_ref) {
  var results = _ref.results,
      formData = _ref.formData,
      disabled = _ref.disabled,
      withHighlights = _ref.withHighlights,
      withLinks = _ref.withLinks,
      columnEventType = _ref.columnEventType,
      columnActCode = _ref.columnActCode;
  var intl = useIntl();

  var renderRow = function renderRow(entry, index) {
    var GenderCmp = entry.gender ? GenderMale : GenderFemale;
    var genderColor = entry.gender ? 'color-male' : 'color-female';

    var TextTd = function TextTd(_ref2) {
      var children = _ref2.children,
          other = _objectWithoutProperties(_ref2, _excluded);

      return /*#__PURE__*/_jsx("td", _objectSpread(_objectSpread({}, other), {}, {
        onClick: function onClick(e) {
          if (e.detail === 2) {
            // Double click
            var target = e.target;
            selectElementText(target);
          }
        },
        children: children
      }));
    };

    var handleChildClick = function handleChildClick(e) {
      if (e.detail === 2) {
        var target = e.target;
        selectElementText(target.parentElement);
        e.stopPropagation();
      }
    };

    var surnameNeedles = tokenizeAndNormalizeText(formData.surname || '');
    var givenNameNeedles = tokenizeAndNormalizeText(formData.givenName || '');

    var HighlightFuzzy = function HighlightFuzzy(_ref3) {
      var text = _ref3.text,
          needles = _ref3.needles;

      if (text && withHighlights) {
        var parts = tokenizeText(text);
        return parts.map(function (token, i) {
          return /*#__PURE__*/_jsx(React.Fragment, {
            children: i % 2 === 0 ? needles.includes(normalizeTextToken(token)) ? /*#__PURE__*/_jsx("strong", {
              onClick: handleChildClick,
              children: token
            }) : token : token
          }, i);
        });
      } else {
        return text || null;
      }
    };

    var HighlightSuffix = function HighlightSuffix(_ref4) {
      var text = _ref4.text,
          suffix = _ref4.suffix;

      if (text && withHighlights && suffix != null && text.endsWith(suffix)) {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [text.substring(0, text.length - suffix.length), /*#__PURE__*/_jsx("strong", {
            onClick: handleChildClick,
            children: text.substring(text.length - suffix.length)
          })]
        });
      } else {
        return text || null;
      }
    };

    var HighlightConditional = function HighlightConditional(_ref5) {
      var children = _ref5.children,
          isHighlighted = _ref5.isHighlighted;
      return withHighlights && isHighlighted ? /*#__PURE__*/_jsx("strong", {
        onClick: handleChildClick,
        children: children
      }) : children;
    };

    var LinkWhenAvailable = function LinkWhenAvailable(_ref6) {
      var children = _ref6.children,
          urls = _ref6.urls;

      if (urls && withLinks) {
        var url = urls[intl.locale] || urls['fr'] || urls['en']; // This should be the expected behavior

        return url ? /*#__PURE__*/_jsx("a", {
          href: url,
          target: "_blank",
          rel: "noreferrer",
          className: "table-row-link",
          children: children
        }) : children;
      } else {
        return children;
      }
    };

    var placeText = formData.place.length > 0 ? formData.place[0].fullname : null;
    var hasYearFilter = formData.rangeType === RANGE_BETWEEN && (formData.yearAfter !== undefined || formData.yearBefore !== undefined) || (formData.rangeType === RANGE_AFTER || formData.rangeType === RANGE_BEFORE || formData.rangeType === RANGE_EXACT || formData.rangeType === RANGE_ABOUT) && formData.year !== undefined;
    return /*#__PURE__*/_jsxs("tbody", {
      children: [/*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("td", {
          rowSpan: 2,
          className: "text-center",
          children: /*#__PURE__*/_jsx("span", {
            title: intl.formatMessage({
              id: entry.gender ? 'result.gender.male' : 'result.gender.female'
            }),
            children: /*#__PURE__*/_jsx(GenderCmp, {
              className: "icon icon-gender ".concat(genderColor)
            })
          })
        }), /*#__PURE__*/_jsx(TextTd, {
          rowSpan: 2,
          children: /*#__PURE__*/_jsx(LinkWhenAvailable, {
            urls: entry.wikipedia,
            children: /*#__PURE__*/_jsx(HighlightFuzzy, {
              text: entry.nom,
              needles: surnameNeedles
            })
          })
        }), /*#__PURE__*/_jsx(TextTd, {
          rowSpan: 2,
          children: /*#__PURE__*/_jsx(LinkWhenAvailable, {
            urls: entry.wikipedia,
            children: /*#__PURE__*/_jsx(HighlightFuzzy, {
              text: entry.prenom,
              needles: givenNameNeedles
            })
          })
        }), columnEventType && /*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "common.event.birth"
          })
        }), /*#__PURE__*/_jsx(TextTd, {
          children: /*#__PURE__*/_jsx(HighlightConditional, {
            isHighlighted: formData.sortBy === EVENT_TYPE_BIRTH && hasYearFilter,
            children: entry.birthDate ? /*#__PURE__*/_jsx("time", {
              dateTime: entry.birthDate,
              children: /*#__PURE__*/_jsx(FormattedDate, {
                value: entry.birthDate,
                timeZone: "UTC"
              })
            }) : null
          })
        }), /*#__PURE__*/_jsx(TextTd, {
          children: /*#__PURE__*/_jsx(HighlightSuffix, {
            text: entry.birthPlace,
            suffix: placeText
          })
        }), columnActCode && /*#__PURE__*/_jsx("td", {
          rowSpan: 2,
          className: "text-center",
          children: !!entry.actCode && /*#__PURE__*/_jsx(FormattedMessage, {
            id: "common.numbering",
            values: {
              number: entry.actCode
            }
          })
        })]
      }), /*#__PURE__*/_jsxs("tr", {
        children: [columnEventType && /*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "common.event.death"
          })
        }), /*#__PURE__*/_jsx(TextTd, {
          children: /*#__PURE__*/_jsx(HighlightConditional, {
            isHighlighted: formData.sortBy === EVENT_TYPE_DEATH && hasYearFilter,
            children: entry.deathDate ? /*#__PURE__*/_jsx("time", {
              dateTime: entry.deathDate,
              children: /*#__PURE__*/_jsx(FormattedDate, {
                value: entry.deathDate,
                timeZone: "UTC"
              })
            }) : null
          })
        }), /*#__PURE__*/_jsx(TextTd, {
          children: /*#__PURE__*/_jsx(HighlightSuffix, {
            text: entry.deathPlace,
            suffix: placeText
          })
        })]
      })]
    }, index);
  };

  return /*#__PURE__*/_jsxs(Table, {
    responsive: true,
    className: "result-table ".concat(disabled ? 'group-disabled' : ''),
    children: [/*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "result.header.gender"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "result.header.surnames"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "result.header.given_names"
          })
        }), columnEventType && /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "result.header.event"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "result.header.date"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "result.header.place"
          })
        }), columnActCode && /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "result.header.act_code"
          })
        })]
      })
    }), results.map(renderRow)]
  });
}
ResultListTable.propTypes = {
  results: PropTypes.arrayOf(PropTypes.shape({
    birthDate: PropTypes.string,
    birthPlace: PropTypes.string,
    deathDate: PropTypes.string,
    deathPlace: PropTypes.string,
    gender: PropTypes.bool.isRequired,
    nom: PropTypes.string,
    prenom: PropTypes.string
  })).isRequired,
  formData: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  withHighlights: PropTypes.bool,
  withLinks: PropTypes.bool,
  columnEventType: PropTypes.bool,
  columnActCode: PropTypes.bool
};
ResultListTable.defaultProps = {
  disabled: false,
  withHighlights: false,
  withLinks: false,
  columnEventType: false,
  columnActCode: false
};